import classNames from 'classnames'
import React from 'react'

import { CircularProgress, Fade } from '@mui/material'
import { createStyles, withStyles, WithStyles } from '@mui/styles'

const SectionLoading: React.SFC<SectionLoadingProps & WithStyles<typeof styles>> = ({ classes, className }) => {
  return (
    <Fade in={true}>
      <div className={classNames(className, classes.loaderContainer)}>
        <CircularProgress size={50} color="secondary" />
      </div>
    </Fade>
  )
}

export type SectionLoadingProps = {
  className?: string
}

const styles = createStyles({
  loaderContainer: {
    display: 'flex',
    height: '50vh',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export default withStyles(styles)(SectionLoading)
